import { __ } from '@wordpress/i18n';
const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes, className }) => {
  return (
    <div className={ className }>
      <div className="wrapper Container">
        <InnerBlocks.Content />

        <div className="testimonial">
          <div className="testimonial__info">
            <div className="testimonial__logo">
              <img src={attributes.url_1} />
            </div>

            <div className="testimonial__description">
              <div className="testimonial__stars">
                <img src="./../wp-content/themes/wpensar/assets/blocks/images/five-stars.png"/>
              </div>

              <RichText.Content
              tagName="span"
              className="testimonial__name"
              value={attributes.name_1}
              />

              <RichText.Content
              tagName="span"
              className="testimonial__subtitle"
              value={attributes.subtitle_1}
              />
            </div>
          </div>

          <div className="testimonial__text">
            <RichText.Content
              tagName="p"
              className=""
              value={attributes.description_1}
            />
          </div>
        </div>

        <div className="testimonial">
          <div className="testimonial__info">
            <div className="testimonial__logo">
              <img src={attributes.url_2} />
            </div>

            <div className="testimonial__description">
              <div className="testimonial__stars">
                <img src="./../wp-content/themes/wpensar/assets/blocks/images/five-stars.png"/>
              </div>

              <RichText.Content
              tagName="span"
              className="testimonial__name"
              value={attributes.name_2}
              />

              <RichText.Content
              tagName="span"
              className="testimonial__subtitle"
              value={attributes.subtitle_2}
              />
            </div>
          </div>

          <div className="testimonial__text">
            <RichText.Content
              tagName="p"
              className=""
              value={attributes.description_2}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
